import { cn } from '@/lib/utils'
import React from 'react'

interface MarqueeProps {
  children: React.ReactNode
  className?: string
  speed?: number // 滚动速度（秒），默认30秒
  pauseOnHover?: boolean // 鼠标悬停暂停，默认true
  direction?: 'left' | 'right' // 滚动方向，默认left
}

export function Marquee({
  children,
  className,
  speed = 30,
  pauseOnHover = true,
  direction = 'left',
}: MarqueeProps) {
  return (
    <div
      className={cn(
        'relative flex overflow-hidden',
        className
      )}
    >
      <div
        className={cn(
          'flex min-w-full shrink-0 items-center gap-4',
          pauseOnHover && 'hover:[animation-play-state:paused]'
        )}
        style={{
          animation: `marquee ${speed}s linear infinite`,
          animationDirection: direction === 'right' ? 'reverse' : 'normal',
        }}
      >
        {children}
      </div>
      {/* 复制一份内容实现无缝循环 */}
      <div
        className={cn(
          'flex min-w-full shrink-0 items-center gap-4',
          pauseOnHover && 'hover:[animation-play-state:paused]'
        )}
        style={{
          animation: `marquee ${speed}s linear infinite`,
          animationDirection: direction === 'right' ? 'reverse' : 'normal',
        }}
        aria-hidden="true"
      >
        {children}
      </div>

      {/* CSS动画定义（vite 项目无 styled-jsx，此处由 vite + React 直接注入 <style>） */}
      {/* @ts-expect-error styled-jsx 不在 Vite 下启用，但 <style> 标签仍可注入 CSS */}
      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </div>
  )
}
